import { BifrostLoader } from "@/Components/elements"
import { Feed, Label, Message } from "semantic-ui-react"
import BifrostWaringIcon from "../../../BifrostElementComponent/BifrostWarningIcon/BifrostWaringIcon.jsx"
import { useServiceStatus } from "../hooks/useServiceStatus.js"

const ServiceStatus = ({ directTunnelServiceStatus }) => {
	const { serviceStatus } = useServiceStatus(directTunnelServiceStatus)

	return (
		<Feed.Content>
			<Feed.Summary>Service Status {directTunnelServiceStatus.error && <BifrostWaringIcon content={directTunnelServiceStatus.error} />}</Feed.Summary>
			<Feed.Extra text className={"device-change-disabled"} style={{ justifyContent: "space-between" }}>
				<div style={{ display: "flex", alignItems: "center", width: "100%" }}>
					<Message
						size="mini"
						content={serviceStatus.connected}
						positive={serviceStatus.connected === "Connected"}
						negative={serviceStatus.connected === "Disconnected"}
						style={{ paddingTop: "7px", paddingBottom: "9px", marginBottom: "0px" }}
					/>
					<BifrostLoader backgroundColor="white" inverted size="small" height="40px" minHeight="20px" isLoading={directTunnelServiceStatus.isFetching} style={{ marginLeft: "10px" }} />
					{serviceStatus.lastSeen && (
						<Label basic size="mini" pointing="left" style={{ marginLeft: "20px" }}>
							Last Seen: {serviceStatus.lastSeen}
						</Label>
					)}
				</div>
			</Feed.Extra>
		</Feed.Content>
	)
}

export default ServiceStatus
